export default {
  namespaced: true,
  state: {
    acceptAction: null,
    declineAction: null,
    actions: [],
    active: false,
    message: null,
    notes: null,
    type: 'yes/no',
    icon: 'mdi-alert',
    iconColor: 'primary'
  },
  mutations: {
    setActive(state, active) {
      state.active = active;
    },
    confirm(
      state,
      { acceptAction, declineAction, actions, message, notes, icon, type, iconColor }
    ) {
      state.acceptAction = acceptAction;
      state.declineAction = declineAction;
      state.actions = actions || [];
      state.active = true;
      state.message = message;
      state.notes = notes;
      state.icon = icon || 'mdi-alert';
      state.type = type || 'yes/no';
      state.iconColor = iconColor || 'primary';
    },
    close(state) {
      state.acceptAction = null;
      state.declineAction = null;
      state.active = false;
      state.message = null;
      state.notes = null;
      state.icon = 'mdi-alert';
      state.type = 'yes/no';
      state.color = 'primary';
    },
    resetState(state) {
      state.acceptAction = null;
      state.declineAction = null;
      state.active = false;
      state.message = null;
      state.notes = null;
      state.icon = 'mdi-alert';
      state.type = 'yes/no';
      state.color = 'primary';
    }
  }
};
